import * as THREE from 'three'
import Experience from '../Experience'

export default class Cloud {
  constructor() {
    //setup
    this.experience = new Experience()
    this.scene = experience.scene
    this.resources = experience.resources
    //Options
    this.resource = this.resources.items.cloud

    //Methods
    this.setModel()
  }

  setModel() {
    this.model = this.resource.scene
    this.model.scale.set(0.4, 0.4, 0.4)
    this.scene.add(this.model)
  }
}
